import React from 'react';

const Title = () => {
    return (
        <>
            <h1 style={{fontSize: '28px', lineHeight:'32px', marginTop: '0'}}>The History of<br/>the&nbsp;Pussy&nbsp;Palace</h1>
            <h2 style={{marginTop:'-10px', fontSize: '22px', letterSpacing: '2px', marginBottom:'40px'}}>A DIGITAL EXHIBIT</h2>
        </>
    )
}

export default Title;